import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { memo } from "react";
import { ColorsProvider } from "../providers/ColorsProvider";
import { SlotsProvider } from "../providers/SlotsProvider";
import { useDefaultProps } from "../providers/utils/defaultProps";
import { mergeSx } from "../system";
import { Grid } from "./Grid";
import { Stack } from "./Stack";
import { Typography } from "./Typography";
export const infoCellClasses = {
    root: "MinervaInfoCell-root",
    tonal: "MinervaInfoCell-tonal",
    outlined: "MinervaInfoCell-outlined",
    "title-subtitle-container": "MinervaInfoCell-titleSubtitleContainer",
    "title-subtitle-wrapper": "MinervaInfoCell-titleSubtitleWrapper",
    "subtitle-container": "MinervaInfoCell-subtitleContainer",
};
export const infoCellSlots = {
    title: Typography,
    subtitle: Typography,
};
export const infoCellVariants = ["tonal", "outlined"];
export const InfoCell = memo((props) => {
    const { title, subtitle, variant = "tonal", density = "comfortable", startNode, endNode, subNode, color = "surface", colorSet, invertColors, slots, slotProps, className, sx, ...rest } = useDefaultProps({ component: "InfoCell", props });
    return (_jsx(SlotsProvider, { baseSlots: infoCellSlots, slots: slots, children: ({ title: Title, subtitle: Subtitle }) => (_jsx(ColorsProvider, { color: color, colorSet: colorSet, invertColors: !invertColors, children: (colorStyles) => (_jsxs(Grid, { container: true, gap: 2, alignItems: "center", flexWrap: "nowrap", className: clsx([
                    className,
                    infoCellClasses.root,
                    variant === "tonal" && infoCellClasses.tonal,
                    variant === "outlined" && infoCellClasses.outlined,
                ]), sx: mergeSx({
                    boxSizing: "border-box",
                    padding: density === "comfortable" ? 4 : density === "dense" ? 3 : 0,
                    color: colorStyles.color,
                    backgroundColor: "transparent",
                    borderRadius: (theme) => theme.radius.default,
                    [`&.${infoCellClasses.outlined}`]: {
                        boxShadow: (theme) => `inset 0 0 0 1px ${theme.palette.stroke[100]}`,
                    },
                }, sx), ...rest, children: [startNode, _jsxs(Stack, { flex: 1, minWidth: 0, gap: 0.5, className: infoCellClasses["title-subtitle-container"], children: [typeof title === "string" ? (_jsx(Title, { truncate: true, variant: "body3", fontWeight: "semibold", ...slotProps?.title, children: title }, "infoCell-title")) : (title), typeof subtitle === "string" ? (_jsx(Subtitle, { variant: "body3", truncate: true, ...slotProps?.subtitle, children: subtitle }, "infoCell-subtitle")) : (subtitle), subNode] }), endNode] })) })) }));
});
//# sourceMappingURL=InfoCell.js.map